export function transformForm (form) {
  const formEl = form.getFormElem()[0]
  formEl.querySelectorAll('.mktoFormRow').forEach(row => {
    if(row.querySelector('input[type="hidden"]')) {
      row.classList.add('hidden')
    }
  })
  formEl.removeAttribute('style', '')
  formEl.querySelectorAll('select').forEach(select => {
    const wrap = document.createElement('div')
    wrap.setAttribute('class', 'dropdown')
    select.before(wrap)
    const arrow = document.createElement('div')
    arrow.setAttribute('class', 'arrow')
    arrow.innerHTML = '<svg width="13" height="8" viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6.6 6.8L12.2 1" stroke="currentColor"/></svg>'
    wrap.append(arrow)
    wrap.append(select)
  })
  formEl.querySelectorAll('input[type=checkbox], .mktoHtmlText, textarea, .mktoRadioList').forEach(el => {
    el.closest('.mktoFormRow').classList.add('fill-row')
  })
  formEl.querySelectorAll('.mktoRadioList').forEach(listEl => {
    listEl.querySelectorAll('input').forEach((inputEl, index) => {
      const label = inputEl.nextElementSibling
      const wrapEl = document.createElement('div')
      wrapEl.classList.add('radio-item')
      listEl.append(wrapEl)
      wrapEl.append(inputEl)
      wrapEl.append(label)
    })
  })
}